import { createContext, useContext } from 'react';

/**
 * The streaming state of a single markdown block within an `AiResponse`.
 * @internal
 */
export interface AiResponseBlockState {
  /**
   * Whether the markdown block has been fully received. It is `false` while the block
   * ends inside a code fence whose closing fence is still missing.
   */
  isComplete: boolean;
}

export const AiResponseBlockContext = createContext<AiResponseBlockState>({
  isComplete: true,
});

/**
 * Returns the streaming state of the markdown block the calling component is rendered in.
 * @internal
 */
export const useAiResponseBlock = (): AiResponseBlockState =>
  useContext(AiResponseBlockContext);
